import type { SDKOptions } from "@/state/sdk-options";
import { SDKActionRegistry } from "./sdk-action-registry";
import { SDKAuthState } from "./sdk-auth-state";
import { Logger } from "@/utils/logger";
import { SDKChannelInfoState } from "./sdk-channel-info-state";

export class SDKState {
  isInitialized = false;
  actionRegistry: SDKActionRegistry;
  authState: SDKAuthState;
  channelInfo: SDKChannelInfoState;
  #logger: Logger;
  #maybeOptions?: SDKOptions;

  constructor(
    logger: Logger,
    authState?: SDKAuthState,
    channelInfo?: SDKChannelInfoState,
    actionRegistry?: SDKActionRegistry,
    options?: SDKOptions,
  ) {
    this.#maybeOptions = options;
    this.authState = authState ?? new SDKAuthState(logger);
    this.channelInfo = channelInfo ?? new SDKChannelInfoState(logger);
    this.#logger = logger.extend(this.constructor.name);
    this.actionRegistry = actionRegistry ?? new SDKActionRegistry(this.#logger);
  }

  get options(): SDKOptions {
    if (!this.#maybeOptions) {
      throw new Error(this.#logger.prefixMessage("SDK options are not set"));
    }
    return this.#maybeOptions;
  }

  get clientId(): string {
    if (!this.options?.clientId) {
      throw new Error(this.#logger.prefixMessage("Client ID is not set"));
    }

    return this.options.clientId;
  }

  init(options: SDKOptions) {
    this.#maybeOptions = options;
    this.isInitialized = true;

    this.#logger.debug("SDK state initialized");
  }
}
